import IAlert from "@/models/modelView/IAlert";
import FormatDate from "@/utils/date.util";
import { MapsUtil } from "@/utils/maps.util";
import BasePopup from "./base.popup";

export default class AlertsPopup implements BasePopup {
    alert: IAlert
    offSet = [0, -40]

    constructor(feature: any) {
        this.alert = feature.get("alert")
    }

    getParamsAddress(): { id: string; lat: number; lon: number; } {
        return {
            id: 'alert_' + this.alert.id,
            lat: this.alert.latitude,
            lon: this.alert.longitude,
        }
    }
    getContent(): string {
        const attributes = this.alert.data
        let extraRows = ''
        attributes.forEach(item => {
            extraRows += `
            <div class="lineas">
                <p class="propiedad m-0">${item.title} </p>
                <p class="valor m-0 ms-1">${item.value}</p>
            </div>
            `
        })
        return `
        <div class="cajatitle">
            <img src=${require('@/assets/img/alerts/' + this.alert.icon + '.png')} >
            <p class="m-0 ms-1 fw-bold fs-6">${this.alert.title}</p>
        </div>
        <hr >
        <div class="lineas align-items-center">
            <p class="propiedad m-0">Unidad: </p>
            <p class="valor m-0 ms-1">
                <img class="w-auto p-0" style="height: 25px" src=${require('@/assets/img/devices/' + this.alert.device_icon + '.png')} >
                ${this.alert.plate}
            </p>
        </div>
        <div class="lineas">
            <p class="propiedad m-0">Fecha: </p>
            <p class="valor m-0 ms-1">${FormatDate.getGenericFormat(this.alert.time || '')}</p>
        </div>
        ${extraRows}
        <div class="lineas">
            <p class="propiedad m-0">Dirección: </p>
            <p class="valor m-0 ms-1" id="alert_${this.alert.id}"></p>
        </div>
        <div class="lineas">
            <a class="link" href="${MapsUtil.getGoogleMapsURL(this.alert.latitude, this.alert.longitude)}" target="_blank" rel="noopener noreferrer">Link Google Maps</a>
        </div>`
    }
}